<template>
  <CheckpointsCarousel
    v-if="productResponse && !shouldDisplayNewVerifiedRefurbishedCarousel"
    :category-id="productResponse.tracking.categoryId"
    class="pb-48"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import CheckpointsCarousel from '~/scopes/product-core/components/presentationals/CheckpointsCarousel/CheckpointsCarousel.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const experiments = useExperiments()

const shouldDisplayNewVerifiedRefurbishedCarousel = computed(
  () =>
    experiments['experiment.ppVerifiedRefurbishedCarouselV2'] ===
    'withNewDesign',
)
</script>
